<template>
  <div class="app-container">
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'Form.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
        <el-button
          v-auth="'Form.export'"
          class="action-item"
          icon="el-icon-download"
          type="primary"
          @click="ExportExcel"
        >导出</el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <!--列开始-->
      <!-- <el-table-column type="selection"></el-table-column> -->
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <el-table-column label="姓名" prop="examinee.name" align="center" />
      <el-table-column label="手机号" prop="examinee.phone" align="center" />
      <el-table-column label="身份证号" prop="examinee.id_card" align="center" />
      <el-table-column align="center" prop="status_text" label="状态"></el-table-column>
      <el-table-column align="center" prop="create_time" width="180" label="报名时间" sortable></el-table-column>
      <!-- 自定义表单字段 START -->
      <!-- <el-table-column v-for="(item, index) in field" :key="index" align="center" :prop="item.field" :label="item.name">
        <template v-if="item.formtype == 'image' || item.formtype == 'images'" scope="{row}">
          <el-image v-if="row[item.field].length < 1" style="width: 100px; height: 100px" :src="'/zanwu.png'"
            fit="cover"></el-image>
          <el-image v-for="(image, i) in row[item.field]" :key="i" style="width: 100px; height: 100px"
            :src="image == undefined ? '/zanwu.png' : image.path" fit="cover"></el-image>
        </template>
        <template v-else-if="item.formtype == 'file' || item.formtype == 'files'" scope="{row}">
          <el-tag v-if="row[item.field].length < 1" type="danger">暂无文件</el-tag>
          <a v-for="(file, f) in row[item.field]" :key="f" :href="file.path">
            <el-tag type="success"> {{ file.original_name }} </el-tag>
          </a>
        </template>
        <template v-else-if="item.formtype == 'box'" scope="{row}">
          <el-tag type="success">{{ row[item.field] }}</el-tag>
        </template>
        <template v-else-if="item.formtype == 'editor'">
          <el-tag type="success">详情内查看</el-tag>
        </template>
        <template v-else scope="{row}">
          <div>{{ row[item.field] }}</div>
        </template>
      </el-table-column> -->

      <!-- 自定义表单字段 END -->

      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <router-link
            :to="
              '/form/recordsDetail?id=' +
                scopes.row.record_id +
                '&form_id=' +
                scopes.row.form_id
            "
          >
            <el-button type="text" plain icon="el-icon-view" size="mini">
              查看详情
            </el-button>
          </router-link>
          <el-button v-if="scopes.row.status == 1" type="text" plain icon="el-icon-unlock" size="mini" @click="examineVisible = true, temp = scopes.row">
            审核
          </el-button>
          <el-button type="text" plain icon="el-icon-delete" size="mini" @click="RowDelete(scopes.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />

    <el-dialog title="审核" :visible.sync="examineVisible">
      <el-form ref="dataForm" :model="temp" label-position="left" label-width="110px" style="width: 100%">
        <el-form-item label="审核" prop="status">
          <el-radio-group v-model="temp.status">
            <el-radio-button label="2">审核不通过</el-radio-button>
            <el-radio-button label="3">审核通过</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="examineVisible = false">取消</el-button>
        <el-button type="primary" @click="Examine">保存</el-button>
      </div>
    </el-dialog>
    <a ref="aRef" :href="uploadHref" target="_self" style="display: none;"></a>

  </div>

</template>

<script>
// import api from '@/api/examination/records' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
// import FileList from '@/components/attachment/FileList'

const api = {}

export default {
  name: 'Records',
  components: {
    Pagination
    // FileList
  },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id',
        form_id: 0
      },
      field: [],
      temp: {},
      examineVisible: false,
      uploadHref: ''
    }
  },
  created() {
    var form_id = this.$route.fullPath.substring(
      this.$route.fullPath.lastIndexOf('/') + 1
    )
    if (form_id.includes('form_id')) {
      this.listQuery.form_id = this.$route.query.form_id
    } else {
      this.listQuery.form_id = form_id
    }

    if (this.$route.query.examination_id !== undefined) {
      this.listQuery.examination_id = this.$route.query.examination_id
    }
    this.loadData() // 页面加载创建时加载数据
  },
  mounted: function() { },
  methods: {
    Examine() {
      this.api.examine(this.temp).then((response) => {
        this.examineVisible = false
        this.loadData() // 页面加载创建时加载数据
      })
    },
    // 数据导出excel
    // 数据导出excel
    ExportExcel() {
      let url = process.env.VUE_APP_BASE_API + 'admin/records/exportRecord?form_id=' + this.listQuery.form_id
      if (this.listQuery.examination_id !== undefined) {
        url += '&examination_id=' + this.listQuery.examination_id
      }
      if (this.$refs.singleTable.selection.length > 0) {
        var ids = this.$refs.singleTable.selection.map(a => a[this.primary_key])
        url += '&ids=' + ids.join(',')
      }
      this.uploadHref = url += '&sort=' + this.listQuery.sort + '&order=' + this.listQuery.order
      this.$nextTick(() => {
        this.$refs.aRef.click()
      })
    },
    // 加载数据表
    loadData() {
      this.listLoading = true
      // 请求前处理
      this.loadListBefore(this.QueryParams)
      this.api.Query(this.listQuery).then((response) => {
        if (this.afterLoadData) {
          response.data.data = this.afterLoadData(response.data.data)
        }
        this.list = response.data.items
        // this.field = response.data.field;
        this.total = response.data.total
        this.listLoading = false
        this.$previewRefresh() // 为图片预览组件重新刷新url
      })
    },
    // 行删除
    RowDelete(row) {
      var ids = [row[this.primary_key]]
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.api
            .Delete({
              form_id: this.listQuery.form_id,
              ids: ids
            })
            .then((response) => {
              this.$message({ message: '操作成功', type: 'success' })
              this.SearchData() // 重新加载数据
            })
        })
        .catch(() => { })
    },
    // 提交删除
    BatchDelete() {
      if (this.$refs.singleTable.selection.length > 0) {
        var ids = this.$refs.singleTable.selection.map(
          (a) => a[this.primary_key]
        )
        this.$confirm('确定要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.api
              .Delete({
                form_id: this.listQuery.form_id,
                ids: ids
              })
              .then((response) => {
                this.$message({ message: '操作成功', type: 'success' })
                this.SearchData() // 重新加载数据
              })
          })
          .catch(() => { })
      } else {
        this.$message({ message: '请选择删除的数据', type: 'error' })
      }
    }
  }
}
</script>
